/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Material_DamagesInputs */

const en_reports_col_material_damages = /** @type {(inputs: Reports_Col_Material_DamagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material damages`)
};

const pt_br2_reports_col_material_damages = /** @type {(inputs: Reports_Col_Material_DamagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danos Materiais`)
};

/**
* | output |
* | --- |
* | "Material damages" |
*
* @param {Reports_Col_Material_DamagesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_material_damages = /** @type {((inputs?: Reports_Col_Material_DamagesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Material_DamagesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_material_damages(inputs)
	return pt_br2_reports_col_material_damages(inputs)
});